import urls from "global/constants/UrlConstants";
import { getCallParams, makeCall } from "utils/service";

export const fetchTagsCount = async (searchText: string) => {
  const body = {
    searchText: searchText,
    filterType: "",
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_TAGS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchTags = async (
  page: number,
  rowsPerPage: number,
  searchText: string
) => {
  const body = {
    searchText: searchText,
    filterType: "",
  };
  const url = `${urls.GET_ALL_TAGS}/page/${page}/limit/${rowsPerPage}`;
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchFilterTagsCount = async (searchText: string) => {
  const body = {
    searchText: searchText,
    filterType: "",
  };
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(urls.GET_ALL_FILLED_TAGS_COUNT, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchFilterTags = async (
  page: number,
  rowsPerPage: number,
  searchText: string
) => {
  const body = {
    searchText: searchText,
    filterType: "",
  };
  const url = `${urls.GET_ALL_FILLED_TAGS}/page/${page}/limit/${rowsPerPage}`;
  try {
    const callParams = await getCallParams("POST", body);
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactTagCount = async (tagId: number) => {
  const url = `${urls.CONTACT_TAG_COUNT}/${tagId}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const fetchContactTag = async (
  tagId: string,
  page: number,
  rowsPerPage: number
) => {
  const url = `${urls.GET_ALL_TAGS}/${tagId}/page/${page}/limit/${rowsPerPage}`;
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteContactTag = async (tagId: number) => {
  try {
    const callParams = await getCallParams("DELETE");
    const url = `${urls.DELETE_TAGS}/tag/${tagId}`;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const addUpdateContactTag = async (contactId: any, tags: string[]) => {
  try {
    const callParams = await getCallParams("POST", tags);
    const url = `${urls.ADD_UPDATE_TAG}/${contactId}`;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};

export const deleteSingleContactFromTag = async (
  contactId: number,
  tagId: number
) => {
  try {
    const callParams = await getCallParams("DELETE");
    const url = `${urls.DELETE_SINGLE_CONATCT_FROM_TAG}/${contactId}/tagId/${tagId}`;
    const response = await makeCall(url, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
};
